// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { Alert } from '@innolab-trader/tradovate-types'

export interface DismissAlert {
  alertId: number
}

export interface AlertResponse {
  errorText?: string
  alert?: Alert
}

/**
 * Validate DismissAlert request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateDismissAlert(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateDismissAlert(request: DismissAlert): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.alertId === undefined || req.alertId === null) {
    errors.push({
      field: 'alertId',
      code: 'required',
      message: 'alertId is required'
    })
  }

  return errors
}

export const dismissAlert = postEndpoint<DismissAlert, AlertResponse>('/alert/dismissAlert')
